import { RouteRecordRaw } from 'vue-router'

export function createAccountBaseRoute(
  name: string,
  children: RouteRecordRaw[],
): RouteRecordRaw {
  return {
    path: '/accounts/:accountId',
    name,
    component: () => import('@/lib/layouts/DefaultLayout.vue'),
    children,
  }
}
